import React, { Component } from "react";

class SuggestedProducts extends Component {
  getProductImage(product) {
    // TODO: replacem missing image with a fallback image
    if (product.IMAGES) {
      return product.IMAGES[0].IMAGE[0]["_"];
    } else {
      return "no image";
    }
  }

  getProductTitle(product) {
    if(product.NAME){
      return <b>{product.NAME[0]}</b>;
    } else {
      return null;
    }
  }

  getProductPrice(product) {
    if(product.PRICE_VAT){
      return product.PRICE_VAT[0];
    } else {
      return null;
    }
  }

  getProductDescriptionMarkup(product) {
    if(product.SHORT_DESCRIPTION){
    return { __html: product.SHORT_DESCRIPTION[0] };
    }else {
      return null;
    }
  }

  createProductsGroup() {
    const tanksAboveSliced = this.props.tanksAbove;
    const tanksUnderSliced = this.props.tanksUnder;
    const sets = this.props.sets;
    const result = [...tanksAboveSliced, ...tanksUnderSliced, ...sets];
    return result;
  }

  productButtonRedirect(product) {
    const url =
      "https://eshop.destovka.eu/vyhledavani/?string=" +
      encodeURIComponent(product.NAME[0]);
    window.open(url, "_blank");
  }

  render() {
    return (
      <div className="calculator--suggested-results mt">
        {this.createProductsGroup().map((product, index) => (
          <div className="calculator--result-product" key={index}>
            <div className="calculator--result-img-container">
              <img
                onClick={() => this.productButtonRedirect(product)}
                className="calculator--img-resp"
                src={this.getProductImage(product)}
                alt={this.getProductTitle(product)}
              />
            </div>
            <div className="card-body">
              <h5 className="card-title">
                {this.getProductTitle(product)}
              </h5>
              <div
                dangerouslySetInnerHTML={this.getProductDescriptionMarkup(
                  product
                )}/>
              <div className="text-right-align">
                <div className="card-price">
                  Cena: {this.getProductPrice(product)} Kč
                </div>
                <div className="btn-group btn-right">
                  <button
                    className="btn btn-primary"
                    onClick={() => this.productButtonRedirect(product)}
                  >
                    Detail produktu
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
        </div>
    );
  }
}

export default SuggestedProducts;
